import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function CheckinRedirectPage() {
  const [searchParams] = useSearchParams();
  const [showFallback, setShowFallback] = useState(false);

  const poolId = searchParams.get('poolId') ?? '';
  const secret = searchParams.get('secret') ?? '';

  useEffect(() => {
    if (!poolId || !secret) {
      setShowFallback(true);
      return;
    }

    // Try to open the app via custom URL scheme (works if app is installed
    // but Universal Links failed for some reason)
    window.location.href = `sundkortid://checkin?poolId=${encodeURIComponent(poolId)}&secret=${encodeURIComponent(secret)}`;

    // If still here after 1.5 s the app isn't installed — show store links
    const t = setTimeout(() => setShowFallback(true), 1500);
    return () => clearTimeout(t);
  }, [poolId, secret]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a5276] to-[#3d8eb0] flex items-center justify-center px-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full text-center">
        <img src="/logo.png" alt="Sundkortið" className="w-16 h-16 mx-auto mb-4 rounded-2xl" />
        <h1 className="text-xl font-bold text-gray-900 mb-2">Sundkortið</h1>

        {!showFallback ? (
          <p className="text-sm text-gray-500">Opnar forritið…</p>
        ) : (
          <>
            <p className="text-sm text-gray-600 mb-6">
              Sæktu Sundkortið appið til að skrá þig inn í sundlaugina.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="https://apps.apple.com/is/app/sundkortid/id6745040901"
                className="flex items-center justify-center gap-2 bg-black text-white rounded-xl px-5 py-3 text-sm font-semibold hover:bg-gray-900 transition-colors"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                App Store
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=is.sundkortid.app"
                className="flex items-center justify-center gap-2 bg-[#01875f] text-white rounded-xl px-5 py-3 text-sm font-semibold hover:bg-[#016b4c] transition-colors"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.18 23.76c.3.17.64.24.99.2l.11-.04 11.29-6.53-2.43-2.44-9.96 8.81zm-1.42-20.3A1.98 1.98 0 001.5 5v14c0 .54.18 1.03.5 1.42l.07.07 7.84-7.84v-.18L1.83 4.4l-.07.06zm17.65 8.46l-2.21-1.28-2.7 2.7 2.7 2.7 2.23-1.29a2 2 0 000-2.83zM4.17.48L15.46 6.98 13.03 9.4 3.07.59l.02-.02A1.5 1.5 0 014.17.48z"/>
                </svg>
                Google Play
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
